/// <reference path="./muitheme.d.ts" />
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'dark',
        background: {
            default: '#161c24',
            paper: '#212b36',
        },
        text: {
            primary: '#f9fafb',
            secondary: '#919eab',
            disabled: '#454f5b'
        },
        primary: {
            main: '#00A76F'
        },
        secondary: {
            main: '#8E33FF'
        },
        error: {
            main: '#FF5630'
        },
        warning: {
            main: '#FFAB00'
        },
        info: {
            main: '#00B8D9'
        },
        success: {
            main: '#22C55E'
        },
        divider: '#454F5B',

        // *** Custom Colors for Event DetailsContainers ***
        custom: {
            containerGeneral: '#212030',
            containerRewards: '#192430',
            containerRoundDetails: '#192036',
            containerIndividualRound: '#192036',
        }
    }
});

/*****************************************************************************
 ** Style Constants
*****************************************************************************/

export const dramaticBoxShadow = 'rgba(0, 0, 0, 0.2) 0px 5px 5px -3px, rgba(0, 0, 0, 0.14) 0px 8px 10px 1px, rgba(0, 0, 0, 0.12) 0px 3px 14px 2px';
export const basicDropShadow = 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px';

export const boxWithShadowStyle = {
    boxShadow: dramaticBoxShadow,
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '8px'
};

export const gridSpacing = 4;

export default theme;
